export default {
  beforeList: (formValue) => {
    formValue.data.forEach((item) => {
      item.disableDelete = true ;
    });
  }
}